<template>
  <div style="width: 100%; margin-top: 50px">
    <div>
      <mt-header title="用户密码修改">
        <router-link to="/My" slot="left">
          <mt-button icon="back">返回</mt-button>
        </router-link>
        <div slot="right">
          <mt-button class="m-1" @click="submit"
            ><img
              slot="icon"
              src="@/assets/success.png"
              width="24"
              height="24"
            />
          </mt-button>
        </div>
      </mt-header>
    </div>
    <div>
      <mt-field label="用户名" v-model="ruleForm.name" disabled></mt-field>
      <mt-field
        label="原有密码"
        placeholder="请输入原密码"
        type="password"
        v-model="ruleForm.oldpassword"
      ></mt-field>
      <mt-field
        label="新设密码"
        placeholder="请输入新密码"
        type="password"
        v-model="ruleForm.pass"
      ></mt-field>
      <mt-field
        label="确认密码"
        placeholder="请输入确认密码"
        type="password"
        v-model="ruleForm.checkPass"
      ></mt-field>
    </div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
export default {
  created() {
    this.user = this.appApi.getUserData();
    this.passwordVerifyPass = this.user.passwordVerifyPass;
    this.ruleForm.name = this.user.name;
  },
  data() {
    return {
      user: "",
      passwordVerifyPass: true,
      ruleForm: {
        name: "",
        oldpassword: "",
        pass: "",
        checkPass: "",
      },
    };
  },
  methods: {
    //提交按钮
    submit() {
      var valid = this.validatePass();
      console.log(valid);
      if (!valid) {
        return false;
      }

      let oldpassword = this.ruleForm.oldpassword;
      let password = this.ruleForm.pass;

      //console.log(request);
      this.userApi
        .updatePassword(oldpassword, password)
        .then(() => {
          Toast("修改成功,请重登录");
          //清除服务器token缓存
          this.$router.push({ name: "Home" });
        })
        .catch((err) => {
          console.log(err.response.data);
          Toast("密码修改失败");
        });
    },
    validatePass() {
      var pattern = this.user.passwordVerifyPattern;
      var message = this.user.passwordVerifyMessage;
      if (!new RegExp(pattern).test(this.ruleForm.pass)) {
        Toast(message);
        return false;
      }
      if (this.ruleForm.pass != this.ruleForm.checkPass) {
        Toast("两次密码不同!");
        return false;
      }
      return true;
    },
    //返回
    toCancel() {
      this.$router.push({ name: "My" });
    },
  },
};
</script>
<style lang="less" scoped>
.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .miniTool {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>